import React from 'react'
import { useMount } from 'react-use'
import { Redirect } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { stringToLocationObject } from 'lib/location'
import { assert } from 'lib/errors'
import { getOrCreateLoginState } from './Auth'
import { debugLog } from 'lib/console'
import { getLocale } from 'lib/utils/getLocale'

const AuthLoginCallbackHandler = () => {
    const { i18n } = useTranslation()

    const loginState = getOrCreateLoginState()

    assert(loginState?.successTarget, 'Invalid loginState when calling AuthLoginCallbackHandler')

    const target = loginState?.successTarget || `${getLocale(i18n.language) || '/'}`

    useMount(() => debugLog('auth - AuthLoginCallbackHandler - loginState:', loginState))

    const targetLocation = stringToLocationObject(target)

    return <Redirect to={{ ...targetLocation }} />
}

export default AuthLoginCallbackHandler
